import { RestServiceUtils } from "../utils/RestServiceUtils";

const dashboardService = {
    signOut: () => {
        const URL = "/ums/auth/logout";
        return RestServiceUtils.HTTP_POST(URL);
    },

    getDashboardDetails: (organizationId, placeId) => {
        const url = `/ums/${organizationId}/${placeId}`;
        return RestServiceUtils.HTTP_GET(url);
    },
};

export default dashboardService;
